import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { ClassAttendanceRequestModel } from "../ClassAttendanceRequestModel";

@Injectable()
export class DataService_ClassroomAdmin {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadSectionByDate(SchoolID, Date) {
		var postResult$ = new Subject();
		var url = "Section/LoadSectionByDate?SchoolID=" + SchoolID + "&Date=" + Date;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadSemesters(SchoolID) {
		var postResult$ = new Subject();
		var url = "Section/LoadSemesters?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadClassAttendance(EntryDate, MissingSections, CourseID, PeriodID, InstructorPersonID, SchoolID) {
		var postResult$ = new Subject();
		var url =
			"Section/LoadClassAttendance?EntryDate=" +
			EntryDate +
			"&MissingSections=" +
			MissingSections +
			"&CourseID=" +
			CourseID +
			"&PeriodID=" +
			PeriodID +
			"&InstructorPersonID=" +
			InstructorPersonID +
			"&SchoolID=" +
			SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadSectionStudents(SectionID, EntryDate) {
		var postResult$ = new Subject();
		var url = "Section/LoadSectionStudents?SectionID=" + SectionID + "&EntryDate=" + EntryDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadStatusList() {
		var postResult$ = new Subject();
		var url = "Section/LoadStatusList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadExcuses(SchoolID) {
		var postResult$ = new Subject();
		var url = "Section/LoadExcuses?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddClassAttendance(parms: ClassAttendanceRequestModel) {
		var postResult$ = new Subject();
		var url = "Section/AddClassAttendance";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateClassAttendance(parms: ClassAttendanceRequestModel) {
		var postResult$ = new Subject();
		var url = "Section/UpdateClassAttendance";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolOpen(SchoolID, Date) {
		var postResult$ = new Subject();
		var url = "Section/SchoolOpen?SchoolID=" + SchoolID + "&Date=" + Date;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
